import { render } from "./AdminSessions.vue?vue&type=template&id=378c832a&scoped=true"
import script from "./AdminSessions.vue?vue&type=script&lang=js"
export * from "./AdminSessions.vue?vue&type=script&lang=js"

import "./AdminSessions.vue?vue&type=style&index=0&id=378c832a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378c832a"]])

export default __exports__